import React from "react";
import { Modal, ModalProps } from "@medentic/polaris-react";
import { useModalHierarchy } from "@shared/lib";

/**
 * CustomModal - A wrapper around Polaris Modal with built-in modal hierarchy management
 *
 * This component automatically handles:
 * - Modal hierarchy (graying out parent modals when child modals open)
 * - Consistent modal behavior across the application
 * - Easy integration with existing Polaris Modal props
 */

export interface CustomModalProps extends Omit<ModalProps, "children"> {
  /** The content to display inside the modal */
  children?: React.ReactNode;
  /** Whether to enable modal hierarchy management (default: true) */
  enableHierarchy?: boolean;
}

const CustomModal = ({
  open,
  children,
  enableHierarchy = true,
  ...polarisModalProps
}: CustomModalProps) => {
  // Apply modal hierarchy management if enabled
  useModalHierarchy(open && enableHierarchy);

  return (
    <Modal open={open} {...polarisModalProps}>
      {children}
    </Modal>
  );
};

// Export the CustomModal with Modal.Section attached
CustomModal.Section = Modal.Section;

export default CustomModal;
